<template>
  <section class="section-sm">
    <div class="dg-container">
      <div class="row row-grid align-items-center">
        <p class="hp-title2">
          Tokenomics
        </p>
      </div>
      <div class="row row-grid align-items-center mt-4">
        <p class="hp-desc">
          DEGIS will distribute 100 million DEG to reward loyal users
        </p>
      </div>
      <div class="row row-grid align-items-center">
        <div class="col-md-12 pt-2">
          <img src="img/homepage/tokenomics.png" class="img-fluid floating"/>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: "tokennomics",
};
</script>

<style scoped>

</style>
